// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "a2281d8d114e9b5d5b65b7d683ffb87a" + ".css";
};